import { render, staticRenderFns } from "./ListGallery.vue?vue&type=template&id=64050255&scoped=true"
import script from "./ListGallery.vue?vue&type=script&lang=js"
export * from "./ListGallery.vue?vue&type=script&lang=js"
import style0 from "./ListGallery.vue?vue&type=style&index=0&id=64050255&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64050255",
  null
  
)

export default component.exports